export default __webpack_public_path__ + "static/IBMPlexSans-Bold-Latin2-1fb8183e95ac82a40652ed80dc62833d.woff";